import {
  GET_BRANCHES_REQUEST,
  GET_BRANCHES_SUCCESS,
  GET_BRANCHES_ERROR,
  GET_AUDIT_BRANCHES_REQUEST,
  GET_AUDIT_BRANCHES_SUCCESS,
  GET_AUDIT_BRANCHES_ERROR,
  CREATE_BRANCH_REQUEST,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_ERROR,
  UPDATE_BRANCH_REQUEST,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_ERROR,
  DELETE_BRANCH_REQUEST,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_ERROR,
  RESET_BRANCH_STATE,
} from './branchActionTypes';

const initialState = {
  isLoading: false,
  isSuccess: false,
  payload: {},
  message: '',
  branches: [],
  auditBranches: [],
  pagination: {},
};

export default function branchReducer(state = initialState, action) {
  const { type, payload, isLoading, message, isSuccess } = action;

  switch (type) {
    case GET_BRANCHES_REQUEST:
      return {
        ...state,
        isLoading,
      };
    case GET_BRANCHES_SUCCESS:
      return {
        ...state,
        isLoading,
        branches: payload.data,
        pagination: payload,
      };
    case GET_BRANCHES_ERROR:
      return {
        ...state,
        isLoading,
        message,
      };
    case GET_AUDIT_BRANCHES_REQUEST:
      return {
        ...state,
        isLoading,
      };
    case GET_AUDIT_BRANCHES_SUCCESS:
      return {
        ...state,
        isLoading,
        auditBranches: payload.data,
      };
    case GET_AUDIT_BRANCHES_ERROR:
      return {
        ...state,
        isLoading,
        message,
      };
    case CREATE_BRANCH_REQUEST:
      return {
        ...state,
        isLoading,
        isSuccess: false,
      };
    case CREATE_BRANCH_SUCCESS:
      return {
        ...state,
        isLoading,
        isSuccess,
        message,
      };
    case CREATE_BRANCH_ERROR:
      return {
        ...state,
        isLoading,
        isSuccess: false,
        message,
      };
    case UPDATE_BRANCH_REQUEST:
      return {
        ...state,
        isLoading,
        isSuccess: false,
      };
    case UPDATE_BRANCH_SUCCESS:
      return {
        ...state,
        isLoading,
        isSuccess,
        message,
      };
    case UPDATE_BRANCH_ERROR:
      return {
        ...state,
        isLoading,
        isSuccess: false,
        message,
      };
    case DELETE_BRANCH_REQUEST:
      return {
        ...state,
        isLoading,
        isSuccess: false,
      };
    case DELETE_BRANCH_SUCCESS:
      return {
        ...state,
        isLoading,
        isSuccess,
        message,
      };
    case DELETE_BRANCH_ERROR:
      return {
        ...state,
        isLoading,
        isSuccess: false,
        message,
      };
    case RESET_BRANCH_STATE:
      return {
        ...state,
        isSuccess: false,
        message: '',
      };
    default: {
      return state;
    }
  }
}
